/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */
import './port-range.scss';

/* eslint-disable import/no-unresolved, import/default */

import portRangeTemplate from './port-range.tpl.html';

/* eslint-enable import/no-unresolved, import/default */

export default angular.module('tektelic.components.portRange', [])
    .directive('tkPortRange', PortRange)
    .name;

/*@ngInject*/
function PortRange($compile, $templateCache) {

    var linker = function (scope, element, attrs, ngModelCtrl) {

        var template = $templateCache.get(portRangeTemplate);
        element.html(template);

        scope.ngModelCtrl = ngModelCtrl;

        ngModelCtrl.$render = function () {
            if (ngModelCtrl.$viewValue && ngModelCtrl.$viewValue.length) {
                var ports = ngModelCtrl.$viewValue.split(':');
                if (ports[0]) {
                    scope.portFrom = Number(ports[0]);
                }
                if (ports[1]) {
                    scope.portTo = Number(ports[1]);
                }
            } else {
                scope.portFrom = null;
                scope.portTo = null;
            }
        };

        scope.updateView = function () {
            var value = '';
            if (!scope.portFrom) {
                scope.portFrom = null;
            }
            if (!scope.portTo) {
                scope.portTo = null;
            }
            if (scope.portFrom) {
                value += scope.portFrom;
            }
            if (scope.portTo && scope.portTo != scope.portFrom) {
                value += ':' + scope.portTo;
            }
            ngModelCtrl.$setValidity('invalidStartPort', scope.portFrom || (!scope.portFrom && !scope.portTo));
            if (scope.portFrom && scope.portTo && scope.portFrom > scope.portTo) {
                ngModelCtrl.$setValidity('lowerGreaterThanUpper', false);
            } else {
                ngModelCtrl.$setValidity('lowerGreaterThanUpper', true);
            }

            ngModelCtrl.$setViewValue(value);
        };

        scope.$watch('portFrom + portTo', function () {
            scope.updateView();
        });

        $compile(element.contents())(scope);

    }

    return {
        restrict: "E",
        require: "^ngModel",
        scope: {
            titleText: '@',
            disabled: '=ngDisabled',
        },
        link: linker
    };
}



// WEBPACK FOOTER //
// ./src/app/components/port-range.directive.js